<template>
  <footer class="site-footer">
    <LogoMarquee />

    <div class="footer-content">
      <div class="footer-top">
        <p class="copyright">
          &copy; {{ currentYear }} Patio. All rights reserved.
        </p>
        <span class="separator">·</span>
        <router-link to="/terms" class="terms-link">
          Terms &amp; Conditions
        </router-link>
      </div>

      <p class="footer-address-row">
        <span class="address">Pátio Disciplinado — Unipessoal Lda · NIF: 518 316 807 · Incubadora A Praça, Rua dos Três Lagares, Nº 9, 6230-421 Fundão</span>
        <span class="copy-btn-wrapper" :class="{ 'copy-btn-copied': copied }">
          <button class="copy-btn" @click="copyCompanyInfo" title="Copy company details">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
            <span>{{ copied ? 'Copied!' : 'Copy details' }}</span>
          </button>
        </span>
      </p>
    </div>
  </footer>
</template>

<script>
import LogoMarquee from "@/components/LogoMarquee.vue";

export default {
  name: "SiteFooter",
  components: {
    LogoMarquee,
  },
  data() {
    return {
      copied: false,
      currentYear: new Date().getFullYear(),
    };
  },
  methods: {
    async copyCompanyInfo() {
      const text =
        "Pátio Disciplinado — Unipessoal Lda\nNIF: 518 316 807\nIncubadora A Praça, Rua dos Três Lagares, Nº 9, Antiga Praça Municipal, 6230-421 Fundão, Portugal";
      try {
        await navigator.clipboard.writeText(text);
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      } catch {
        // Fallback for older browsers
        const textarea = document.createElement("textarea");
        textarea.value = text;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      }
    },
  },
};
</script>

<style scoped>
.site-footer {
  position: relative;
  bottom: 0;
  width: calc(100% + var(--space) * 2);
  margin-left: calc(var(--space) * -1);
  margin-right: calc(var(--space) * -1);
  margin-bottom: calc(var(--space) * -1);
  background-color: var(--bg-main-dark);
  z-index: 10;
  border-top: 1px solid var(--border-dark);
}

.site-footer :deep(.logo-marquee) {
  border-bottom: 1px solid var(--border-dark);
}

.footer-content {
  padding: var(--space) var(--space) calc(var(--doubleSpace) + env(safe-area-inset-bottom, 0px)) var(--space);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--smallSpace);
}

.footer-top {
  display: flex;
  align-items: center;
  gap: var(--smallSpace);
  flex-wrap: wrap;
}

.copyright {
  font-size: var(--smallFontSize);
  opacity: 0.3;
  margin: 0;
  text-align: left;
}

.separator {
  opacity: 0.3;
  font-size: var(--smallFontSize);
}

.terms-link {
  font-size: var(--smallFontSize);
  color: var(--text-white);
  opacity: 0.3;
  text-decoration: none;
  transition: opacity var(--fastSpeed);
}

.terms-link:hover {
  opacity: 0.7;
}

.copied-text {
  color: #bfff00;
}

.copy-btn-wrapper {
  display: inline;
}

.copy-btn-copied {
  opacity: 1 !important;
  color: #bfff00;
}

.copy-btn-copied .copy-btn {
  color: #bfff00;
  opacity: 1;
}

.footer-address-row {
  margin: 0;
  font-size: var(--smallFontSize);
  color: rgba(204, 204, 204, 0.3);
  text-align: left;
  line-height: 1.6;
}

.address {
  font-size: var(--smallFontSize);
  margin: 0;
}

.copy-btn {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  gap: var(--smallSpace);
  margin-left: var(--smallSpace);
  background: none;
  border: none;
  color: rgba(204, 204, 204, 0.3);
  cursor: pointer;
  padding: 0;
  font-size: var(--smallFontSize);
  height: auto;
  opacity: 1;
  transition: opacity var(--fastSpeed);
}

.copy-btn:hover {
  opacity: 0.7;
  border: none;
  box-shadow: none;
}

.copy-btn:active {
  box-shadow: none;
  border: none;
}

@media screen and (max-width: 768px) {
  .footer-top {
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--smallSpace);
  }

  .address {
    text-align: left;
  }

  .footer-content {
    padding-bottom: calc(var(--doubleLargeSpace) * 2 + env(safe-area-inset-bottom, 0px));
  }
}
</style>
